import React from "react";
import coatingImage from "../../assets/images/High-Quality-CED-Coating.jpg"; // <-- Replace with your actual image path
import { motion } from "framer-motion";

const ExpertiseSection = () => {
  return (
    <section className="w-full bg-[#f9f9f6] py-12 px-4 md:px-16">
      <div className="max-w-[1300px] mx-auto flex flex-col md:flex-row items-center gap-10">
        {/* Image */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex-1"
        >
          <img
            src={coatingImage}
            alt="CED Coating Expertise"
            className="rounded-2xl shadow-lg hover:scale-105 transition-transform duration-500"
          />
        </motion.div>

        {/* Text Content */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="flex-1"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c3e50] mb-6 leading-tight">
            Unmatched Expertise in High-Quality CED Coating and Precision Engineering
          </h2>
          <p className="text-lg text-[#555] leading-relaxed">
            At CED Coatings, we specialize in delivering superior CED coating with high DFT and precision for a wide range of industrial products, from heavy parts to high-precision components. Our capabilities include advanced masking, exceptional quality testing standards, and efficient in-house plant design, ensuring minimal downtime and optimal performance. With the flexibility to expand and adapt, we are prepared to meet evolving customer demands with precision and reliability.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default ExpertiseSection;
